<re-captcha
  class="re-captcha"
  (resolved)="resolved($event)"
  (error)="errored()"
></re-captcha>
<!-- secret -
      6LcrKpwaAAAAAGJ5R_dWSAmYRStPAgBB0jfAbHsx
     -->
       <!-- siteKey="6LcrKpwaAAAAAO-1TpuAK-084u8iebOmYknXLjA6" -->